import { stripHtml } from './Messages';
export const getCopyButtonText = response => {
  const message = response && response.sections && response.sections[0] && 'text' in response.sections[0] && response.sections[0].text || '';
  return stripHtml(message);
};